import { ApiUtility } from "../Utilities/ApiUtility.axios";

export const enum CTConfigurationPageType {
  none = 0,
  TaxRates = 1,
  CapitalAllowance = 2,
  RnDRates = 3,
  AnnualInvestmentAllowance = 4,
  AssetCategories = 5,
  CompanyNames = 6,
}

export enum CapitalAllowanceAssetCategories {
  Unknown,
  MachineryAndPlantSpecial,
  MachineryAndPlantMain,
  OtherChargesAndAllowances,
  StructuresAndBuilding,
  BusinessPremisesRenovationAllowances,
  ElectricCharge,
  EnterpriseZones,
  ZeroEmissionsGoodsVehicles,
  ZeroEmissionsCars,
  KnowHow,
}

export const CapitalAllowanceAssetCategoriesOptionList = [
  {
    value: CapitalAllowanceAssetCategories.MachineryAndPlantSpecial,
    label: "Machinery and plant (Special Rate Pool)",
  },
  {
    value: CapitalAllowanceAssetCategories.MachineryAndPlantMain,
    label: "Machinery and plant (Main Pool)",
  },
  {
    value: CapitalAllowanceAssetCategories.OtherChargesAndAllowances,
    label: "Other allowances and charges",
  },
  {
    value: CapitalAllowanceAssetCategories.StructuresAndBuilding,
    label: "Structures and buildings",
  },
  {
    value: CapitalAllowanceAssetCategories.BusinessPremisesRenovationAllowances,
    label: "Business premises renovation allowance",
  },
  {
    value: CapitalAllowanceAssetCategories.ElectricCharge,
    label: "Electric charge-points",
  },
  {
    value: CapitalAllowanceAssetCategories.EnterpriseZones,
    label: "Enterprise zones",
  },
  {
    value: CapitalAllowanceAssetCategories.ZeroEmissionsGoodsVehicles,
    label: "Zero emissions goods vehicles",
  },
  {
    value: CapitalAllowanceAssetCategories.ZeroEmissionsCars,
    label: "Zero emissions cars",
  },
  {
    value: CapitalAllowanceAssetCategories.KnowHow,
    label: "Patents and know how",
  },
];
export interface CTConfigurationBase {
  startDate: string;
}
export interface CTConfigurationCapitalAllowanceBase {
  name: string;
  fromDate?: string | null;
  toDate?: string | null;
}

class CTConfigurationService {
  route = `/Api/CTConfiguration`;

  getTaxRates = () => ApiUtility.get(`${this.route}/taxrates`);

  saveTaxrates = (year: any, params: any) => ApiUtility.post(`${this.route}/taxrates/${year}`, params);

  getCapitalAllowances = (type: number) => ApiUtility.get(`${this.route}/capitalAllowances/${type}`);

  postCapitalAllowances = (type: number, params: any) => ApiUtility.post(`${this.route}/capitalAllowances/${type}`, params);

  getRnDRates = () => ApiUtility.get(`${this.route}/rndrates`);

  addRnDRateItem = (params: any, id: any) => ApiUtility.post(`${this.route}/addrndrates/${id}`, params);

  getCompanyNames = () => ApiUtility.get(`${this.route}/companynames`);

  addCompanyNames = (params: any, id: any) => ApiUtility.post(`${this.route}/addcompanynames/${id}`, params);

  getAIAs = () => ApiUtility.get(`${this.route}/aias`);

  addAIAsItem = (params: any, id: any) => ApiUtility.post(`${this.route}/addaias/${id}`, params);

  getAssetCategories = (type: number) => ApiUtility.get(`${this.route}/assetcategory/${type}`);

  postAssetCategories = (type: number, params: any) => ApiUtility.post(`${this.route}/assetcategories/${type}`, params);

}

export default new CTConfigurationService();
